// extracted by mini-css-extract-plugin
module.exports = {"marker":"marker-module--marker---9HFH","bounce":"marker-module--bounce--1mECT"};